<template>
    <div>
        <div class="w-100">
            <v-alert type="info" text class="mb-5">
                Le paramétrage des options ne pourra plus être modifié après le premier envoi de la campagne et
                s'appliquera aussi à ses relances.
            </v-alert>
        </div>
        <v-card flat>
            <v-card-text>
                <h4 class="mb-5">Options d'envoi</h4>

                <div class="d-flex" v-if="showDisableEmailOption">
                    <v-checkbox style="padding: 0 !important; margin: 0 !important;"
                                label="Désactiver l'envoi d'e-mails lors du premier envoi" :input-value="noEmail" @change="setNoEmail"
                                hide-details>
                    </v-checkbox>

                    <v-tooltip slot="append-outer" bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon>
                                <v-icon>help</v-icon>
                            </v-btn>
                        </template>
                        <span>Cette option désactive l'envoi d'e-mail de la campagne lors du premier envoi.
                                <br>Le professionnel ne
                                recevra pas d'e-mail lors du 1er envoi, mais sera contacté pour les relances.
                            </span>
                    </v-tooltip>
                </div>
                <div class="d-flex">
                    <v-checkbox style="padding: 0 !important; margin: 0 !important;"
                                label="Envoyer un seul e-mail pour un même destinaire"
                                :input-value="singleEmail" @change="setSingleEmail"
                                hide-details>
                    </v-checkbox>

                    <v-tooltip slot="append-outer" bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon>
                                <v-icon>help</v-icon>
                            </v-btn>
                        </template>
                        <span>
                                Si plusieurs fiches ont le même e-mail : un seul e-mail sera envoyé.
                                <br>
                                Le destinataire aura bien un formulaire pour chaque fiche dans son espace-pro.
                            </span>
                    </v-tooltip>
                </div>
            </v-card-text>
        </v-card>

        <v-card flat>
            <v-card-text>
                <h4 class="mb-5">Suggestion</h4>
                <div class="d-flex">
                    <v-checkbox style="padding: 0 !important; margin: 0 !important;"
                                label="Suggérer des informations dans le formulaire" :input-value="mediaSuggestion"
                                @change="setMediaSuggestion" :disabled="!hasSuggestionOption" hide-details>
                    </v-checkbox>

                    <v-tooltip slot="append-outer" bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon>
                                <v-icon>help</v-icon>
                            </v-btn>
                        </template>
                        <span>Uska recommendera des informations dans le formulaire pour enrichir et faciliter la
                                saisie par le professionnel<br>(ex : le site web, les horaires, les photos,
                                etc.).</span>
                    </v-tooltip>
                </div>
            </v-card-text>
        </v-card>

        <v-card flat>
            <v-card-text>
                <h4 class="mb-5">Spécificités des périodes d'ouvertures et tarifaires</h4>

                <v-radio-group @change="setPeriodsConfig" :value="periodsConfig" class="mt-0">
                    <v-radio label="Pré-remplir avec les périodes en cours de validité (s'il y en a sur votre SIT)"
                             class="mt-auto mb-auto" value="DEFAULT" v-if="account.tis_type.code !== 'DAHUB'">
                    </v-radio>
                    <div class="d-flex">
                        <v-radio label="Ne pas pré-remplir" value="EMPTY" class="mt-auto mb-auto mr-2"></v-radio>

                        <v-tooltip slot="append-outer" bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="gray">help</v-icon>
                            </template>
                            <span>Les périodes sont vierges, le prestataire doit créer de nouvelles périodes.</span>
                        </v-tooltip>
                    </div>
                    <div class="d-flex">
                        <v-radio label="Suggérer des nouvelles périodes" value="SUGGESTIONS"
                                 class="mt-auto mb-auto mr-2"></v-radio>

                        <v-tooltip slot="append-outer" bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="gray">help</v-icon>
                            </template>
                            <span>Des périodes sont automatiquement suggérées dans le formulaire.
                                    <br>Uska en propose de nouvelles en se basant sur les anciennes périodes
                                    existantes.</span>
                        </v-tooltip>
                    </div>
                </v-radio-group>

                <v-alert text type="info">
                    Quand un prestataire soumet son formulaire, un avertissement est affiché si aucune période
                    n'a été saisie.
                </v-alert>
            </v-card-text>
        </v-card>

        <v-card v-if="criterias !== undefined && criterias.length" flat>
            <v-card-text>
                <div class="d-flex">
                    <h4 class="mb-5">Critères internes</h4>
                    <v-tooltip slot="append-outer" right>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon class="align-baseline">
                                <v-icon>help</v-icon>
                            </v-btn>
                        </template>
                        <span>
                  Sélectionnez des critères internes ici, afin qu'ils soient présélectionnés automatiquement
                            sur les réponses avant la mise à jour Apidae. <br>
                                Assurez vous d’avoir au préalable ajouté Uska
                            en tant que Membre collaborateur de vos critères internes sur Apidae.
                            </span>
                    </v-tooltip>
                </div>

                <div class="form-container mr-auto ml-auto">
                    <v-autocomplete :items="criterias" chips deletable-chips label="Sélectionner vos critères internes"
                                    item-text="libelle" item-value="id" hide-details :value="selectedCriterias"
                                    @change="setSelectedCriterias" multiple outlined>
                    </v-autocomplete>
                </div>
            </v-card-text>
        </v-card>

        <div class="text-right mb-5 mt-5" v-if="hideNextButton === undefined || !hideNextButton">
            <v-btn class="default-button" @click="setCurrentStep(parseInt(currentStep) + 1)">Passer à l'étape
                suivante
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "Options",
    props: ["cmajId", "criterias", "isRevival", "cmaj", "hideNextButton", 'hasSuggestionOption'],
    methods: {
        ...mapMutations("createCmaj", ["setCurrentStep",
            "setMediaSuggestion", "setPeriodsConfig", "setSelectedCriterias", "setNoEmail", "setSingleEmail"]),
    },
    computed: {
        ...mapState("createCmaj", [
            "mediaSuggestion",
            "periodsConfig",
            "selectedCriterias",
            "noEmail",
            "singleEmail",
            "currentStep",
        ]),
        ...mapState("account", ["account"]),
        showDisableEmailOption() {
            let show = !this.isRevival

            if (this.cmaj) {
                show = show || this.cmaj.state.code === "WAIT_FIRST_SENT"
            }

            return show
        },
    },
    created() {
        if (this.cmajId === undefined || this.cmajId === null) {
            this.setMediaSuggestion(this.hasSuggestionOption)
        }

        if(this.account.tis_type.code === 'DAHUB') {
          this.setPeriodsConfig('SUGGESTIONS')
        }
    },
}
</script>